import React, { Component } from "react";

// import UI components
import { Row, Col, Button, FormGroup } from "reactstrap";
import { Formik, Form, Field } from "formik";
import CustomisedModal from "components/Application/CustomisedModal";
import Select from "react-select";

// import form validator
import SimpleReactValidator from "simple-react-validator";

// import custom validator
import {
  lessThanFileSizeValidator,
  fileTypeValidator,
  dateValidator,
} from "helpers/customValidator";

// import constants
import { SUBMIT, UPDATE, SUCCESS, DANGER } from "constants/commonConstants";
import { IMAGE_FILE_TYPE } from "helpers/constants";

import { fileCompress, filePreview, formatDate } from "helpers/generalUtils";

import {
  getCouponDetailListRequest,
  updateCouponDetailStatusByCouponDetailIdRequest,
  addCouponDetailRequest,
  updateCouponDetailByCouponDetailIdRequest,
  getProductCategoryListRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import { toastrMessage } from "helpers/messageHelper";

import { jsonToFormData } from "helpers/axiosRequestData";
import { makeCouponDetailSelectField } from "store/CouponDetail/selector";
import { selectSortedProductCategories } from "store/Masters/ProductCategory/selector";
import { createStructuredSelector } from "reselect";

class CouponForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: SUBMIT,
      couponData: couponDataInitialState(),
      imagePreview: null,
    };

    this.validator = new SimpleReactValidator({
      validators: Object.assign(
        lessThanFileSizeValidator(),
        fileTypeValidator(),
        dateValidator()
      ),
    });
  }

  componentDidMount() {
    this.props.getProductCategoryListRequest();
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.couponDetailApiResponse &&
      this.props.couponDetailApiResponse !== nextprops.couponDetailApiResponse
    ) {
      if (nextprops.couponDetailApiResponse.isSuccessResponse) {
        this.props.getCouponDetailListRequest();
        toastrMessage(
          nextprops.couponDetailApiResponse.responseMessage,
          SUCCESS
        );
        this.resetForm(true);
      } else if (!nextprops.couponDetailApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.couponDetailApiResponse.responseMessage,
          DANGER
        );
      }
    }

    if (
      nextprops.couponRecord &&
      this.props.couponRecord !== nextprops.couponRecord
    ) {
      if (nextprops.couponRecord.couponDetailId) {
        const couponRecord = { ...nextprops.couponRecord };
        couponRecord.maxDisc = couponRecord.maxDisc || "";
        couponRecord.startDate = formatDate(couponRecord.startDate);
        couponRecord.endDate = formatDate(couponRecord.endDate);
        this.setState({
          couponData: couponRecord,
          operationType: UPDATE,
          imagePreview: nextprops.couponRecord.couponImageUrl || null,
        });
      } else {
        this.resetForm(false);
      }
    }
  }

  resetForm = (closeModal) => {
    this.setState({
      couponData: couponDataInitialState(),
      imagePreview: null,
      operationType: SUBMIT,
    });
    this.validator.hideMessages();

    if (closeModal) {
      this.props.closeModal();
    }
  };

  handleFilePreview = async (event, setFieldValue) => {
    // check if any one file is selected by user
    if (event.target.files.length > 0) {
      let file = event.target.files[0];

      await setFieldValue("couponImage", file);

      if (this.validator.fieldValid("couponImage")) {
        try {
          let response = await fileCompress(file);
          await setFieldValue("couponImage", response);
          response = await filePreview(response);

          setFieldValue("isImageChanged", true);
          this.setState({ imagePreview: response });
        } catch (error) {
          this.setState({ imagePreview: null });
          setFieldValue("couponImage", "");
        }
      } else {
        this.setState({ imagePreview: null });
      }
    }
  };

  formSubmit = (val) => {
    const values = {
      ...val
    }
    if (this.validator.allValid()) {
      this.setState({ couponData: values });
      if (this.state.operationType === UPDATE) {
        const data = jsonToFormData(values);
        this.props.updateCouponDetailByCouponDetailIdRequest(
          values.couponDetailId,
          data
        );
      } else {
        values.isImageChanged = false;
        const data = jsonToFormData(values);
        this.props.addCouponDetailRequest(data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  removeImage = (values, setFieldValue) => {
    if (values.couponImageUrl) {
      setFieldValue("isImageChanged", true);
    }
    setFieldValue("couponImage", "");
    this.setState({
      imagePreview: null,
    });
  };

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="Coupon"
          onModalDismiss={() => this.resetForm(true)}
        >
          <Formik
            initialValues={this.state.couponData}
            enableReinitialize={true}
            onSubmit={this.formSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Coupon Name</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="couponName"
                          type="text"
                          className="form-control"
                          autoFocus
                        ></Field>
                        {this.validator.message(
                          "couponName",
                          values.couponName,
                          "required"
                        )}
                      </Col>
                    </Row>

                    {/* Coupon Image */}
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Coupon Image</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <div className="d-flex align-items-center">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              name="couponImage"
                              accept="image/*"
                              onClick={(e) => (e.target.value = null)}
                              id="customFile"
                              onChange={(event) =>
                                this.handleFilePreview(event, setFieldValue)
                              }
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="customFile"
                            >
                              {values.couponImage
                                ? values.couponImage.name
                                : "Choose file"}
                            </label>
                          </div>
                          <div className="ml-2">
                            <i
                              onClick={this.removeImage.bind(
                                this,
                                values,
                                setFieldValue
                              )}
                              className="fa fa-times fa-md"
                            ></i>
                          </div>
                        </div>
                        {this.validator.message(
                          "couponImage",
                          values.couponImage,
                          `lessThanFileSize:5242880|fileType:${IMAGE_FILE_TYPE}`
                        )}
                      </Col>
                    </Row>

                    {this.state.imagePreview && (
                      <Row className="form-group">
                        <Col sm="4" lg="3"></Col>
                        <Col sm="8" lg="5">
                          <img
                            className="img-thumbnail"
                            alt={values.couponName}
                            width="200"
                            src={this.state.imagePreview}
                            data-holder-rendered="true"
                          />
                        </Col>
                      </Row>
                    )}

                    {/* Coupon Code */}
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Coupon Code</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="couponCode"
                          type="text"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "couponCode",
                          values.couponCode,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Coupon Desc</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="couponDesc"
                          type="text"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "couponDesc",
                          values.couponDesc,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Discount</label>
                      </Col>
                      <Col xs="3" sm="2" lg="1" className="pr-1">
                        <Field
                          component="select"
                          name="discType"
                          type="text"
                          className="form-control p-2"
                          value={values.discType}
                        >
                          <option value="1">₹</option>
                          <option value="2">%</option>
                        </Field>
                      </Col>
                      <Col xs="9" sm="6" lg="4" className="pl-1">
                        <Field
                          name="discValue"
                          type="number"
                          className="form-control"
                          step=".01"
                        ></Field>
                        {this.validator.message(
                          "Discount Value",
                          values.discValue,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Max Discount</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="maxDisc"
                          type="number"
                          className="form-control"
                          step=".01"
                        ></Field>
                        {this.validator.message(
                          "Max Discount",
                          values.maxDisc,
                          "numeric|min:1,num"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Min Order Value</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="minOrderValue"
                          type="number"
                          className="form-control"
                          step=".01"
                        ></Field>
                        {this.validator.message(
                          "Min Order Value",
                          values.minOrderValue,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Limit Per User</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="limitPerUser"
                          type="number"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "Limit Per User",
                          values.limitPerUser,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Start Date</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="startDate"
                          type="date"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "Start Date",
                          values.startDate,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>End Date</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="endDate"
                          type="date"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "End Date",
                          values.endDate,
                          "required|minDate:" + values.startDate
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Exclude Product Category</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          component={Select}
                          name="excProductCategoryIds"
                          defaultValue={values.excProductCategoryIds.map((id) =>
                            this.props.sortedProductCategories.find(
                              (productCategory) => productCategory.value === id
                            )
                          )}
                          options={this.props.sortedProductCategories}
                          onChange={(opt, e) => {
                            setFieldValue("excProductCategoryIds", [
                              ...opt.map(
                                (productCategory) => productCategory.value
                              ),
                            ]);
                          }}
                          isMulti
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-0 text-right">
                      <div>
                        <Button type="submit" color="primary" className="mr-1">
                          {this.state.operationType}
                        </Button>

                        <Button
                          type="reset"
                          color="secondary"
                          onClick={() => this.resetForm(false)}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  couponDetailApiResponse: makeCouponDetailSelectField(
    "couponDetailApiResponse"
  ),
  sortedProductCategories: selectSortedProductCategories(),
});

const withConnect = connect(mapStatetoProps, {
  getCouponDetailListRequest,
  updateCouponDetailByCouponDetailIdRequest,
  addCouponDetailRequest,
  updateCouponDetailStatusByCouponDetailIdRequest,
  getProductCategoryListRequest,
});

export default compose(withConnect, withRouter)(CouponForm);
//export default withRouter(withConnect)(Index);

function couponDataInitialState() {
  return {
    couponName: "",
    couponImage: "",
    isImageChanged: false,
    couponCode: "",
    couponDesc: "",
    discType: "1",
    discValue: "",
    maxDisc: "",
    minOrderValue: "",
    limitPerUser: "",
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
    excProductCategoryIds: [],
  };
}
